export default __webpack_public_path__ + "static/bmlogo2-a2ad0a8f076dea800ecc1c0c40650059.jpg";